// extracted by mini-css-extract-plugin
module.exports = {"icon":"Review_icon__3MncN","content":"Review_content__1ju5V"};